{
  "header": {
    "name": "Nombre"
  },
  "empty": "No se encontró ninguna red",
  "button": {
    "new": "Nueva red",
    "newSub": "Añadir una subred",
    "update": "Modificar la red",
    "remove": "Eliminar la red"
  },
  "label": "red",
  "validation": {
    "required": "El campo es obligatorio",
    "maxLength": "Longitud máx.: {maxLength}",
    "nameFormat": "El nombre debe contener los siguientes caracteres [a-zA-Z0-9 _.-]",
    "minLength": "Longitud mín.: {minLength}"
  },
  "details": {
    "tab": {
      "device": {
        "label": "Estación local S4"
      },
      "application": {
        "label": "Aplicaciones"
      },
      "user": {
        "label": "Usuarios"
      },
      "userGroup": {
        "label": "Grupos de usuarios"
      },
      "dtwins": {
        "label": "Equipos"
      },
      "sectors": {
        "label": "Sectores"
      }
    },
    "buttons": {
      "create": "Nuevo sector",
      "createSubSector": "Añadir subsector",
      "remove": "Eliminar el sector",
      "attach": {
        "application": "Añadir una aplicación",
        "device": "Añadir un equipo",
        "user": "Añadir un usuario",
        "userGroup": "Añadir un grupo de usuarios",
        "dtwins": "Añadir un equipo"
      },
      "detach": "Retirar de la red",
      "details": "Detalles"
    },
    "currentSelection": "Selección actual"
  },
  "modals": {
    "create": {
      "title": "Crear una nueva red",
      "sector": {
        "label": "Nombre de la red",
        "description": "Descripción"
      }
    },
    "update": {
      "title": "Actualización de una red",
      "sector": {
        "label": "Nombre de la red",
        "description": "Descripción"
      }
    },
    "remove": {
      "title": "Eliminación de la red {sectorName}",
      "description": "¿Está seguro de que quiere eliminar esta red?",
      "notAllowed": "La eliminación de un sector no es posible; hay algunos equipos conectados a él",
      "titleAlt": "Eliminar el sector"
    },
    "confirmDetach": {
      "device": {
        "title": "Separación del equipo de una red",
        "description": "El equipo \"{name}\" va a separarse de la red \"{sectorLabel}\" | Los siguientes equipos van a separarse de la red \"{sectorLabel}\"",
        "warning": "El equipo separado de toda red dejará de aparecer en las pantallas de gestión (según los derechos de los usuarios). | Los equipos separados de toda red dejarán de aparecer en las pantallas de gestión (según los derechos de los usuarios)."
      },
      "application": {
        "title": "Separación de la aplicación de una red",
        "description": "La aplicación \"{name}\" va a separarse de la red \"{sectorLabel}\" | Las siguientes aplicaciones van a separarse de la red \"{sectorLabel}\"",
        "warning": "La aplicación separada de toda red dejará de aparecer en las pantallas de gestión (según los derechos de los usuarios). | Las aplicaciones separadas de toda red dejarán de aparecer en las pantallas de gestión (según los derechos de los usuarios)."
      },
      "user": {
        "title": "Separación de un usuario de una red",
        "description": "El usuario \"{name}\" va a separarse de la red \"{sectorLabel}\" | Los siguientes usuarios van a separarse de la red \"{sectorLabel}\"",
        "warning": "El usuario separado de toda red ya no podrá acceder a la visualización y gestión de los equipos/las aplicaciones. | Los usuarios separados de toda red ya no podrán acceder a la visualización y gestión de los equipos/las aplicaciones."
      },
      "userGroup": {
        "title": "Separación de un grupo de usuarios de una red",
        "description": "El grupo de usuarios \"{name}\" va a separarse de la red \"{sectorLabel}\" | Los siguientes grupos de usuarios van a separarse de la red \"{sectorLabel}\"",
        "warning": "El grupo de usuarios separado de toda red ya no podrá acceder a la visualización y gestión de los equipos/las aplicaciones. | Los grupos usuarios separados de toda red ya no podrán acceder a la visualización y gestión de los equipos/las aplicaciones."
      },
      "errors": {
        "list_empty": "Debe seleccionar como mínimo un elemento que separar"
      },
      "dtwins": {
        "title": "Separación del equipo de una red",
        "description": "El equipo \"{name}\" va a separarse de la red \"{sectorLabel}\" | Los siguientes equipos van a separarse de la red \"{sectorLabel}\"",
        "warning": "El equipo separado de toda red dejará de aparecer en las pantallas de gestión (según los derechos de los usuarios). | Los equipos separados de toda red dejarán de aparecer en las pantallas de gestión (según los derechos de los usuarios)."
      }
    },
    "attach": {
      "device": {
        "title": "Volver a añadir equipos a una red",
        "description": "Marcar los equipos que se volverán a añadir a la red"
      },
      "application": {
        "title": "Volver a añadir aplicaciones a una red",
        "description": "Marcar las aplicaciones que se volverán a añadir a la red"
      },
      "user": {
        "title": "Volver a añadir usuarios a una red",
        "description": "Marcar los usuarios que se volverán a añadir a la red"
      },
      "userGroup": {
        "title": "Volver a añadir grupos de usuarios a una red",
        "description": "Marcar los grupos de usuarios que se volverán a añadir a la red"
      },
      "errors": {
        "list_empty": "Debe seleccionar como mínimo un elemento que añadir"
      },
      "dtwins": {
        "description": "Marcar los equipos que se volverán a añadir a la red",
        "title": "Volver a añadir equipos a una red"
      }
    },
    "view": {
      "title": "Ver un sector"
    }
  },
  "search": "Búsqueda por nombre",
  "filters": {
    "information": "Seleccione sus sectores de trabajo. Esto afectará a los elementos que podrá manipular en todas las pantallas LX CONNECT."
  },
  "select": {
    "all": "Seleccionar todas las redes",
    "selected": "redes seleccionadas"
  },
  "treeview": {
    "actionsButton": {
      "title": "Acciones"
    }
  },
  "selectedUsers": "No hay usuarios seleccionados | {count} usuario seleccionado | {count} usuarios seleccionados",
  "selectedUserGroups": "No hay grupos seleccionados | {count} grupo seleccionado | {count} grupos seleccionados"
}
